import customaxios from ".";
import { getCurrentUserDetails } from "../common/routines/user-operations";
import qs from "qs";


const preneedDetails = localStorage.getItem("preneedDetails");
const parsed = preneedDetails ? JSON.parse(preneedDetails) : null;
const token = parsed?.accessToken || parsed?.access_token || "";

//  common header (same as your curl)
const authHeader = token
  ? { Authorization: `Bearer ${token}` }
  : undefined;

/**
 * 1) Calendar (month view) - dots/marked days
 * GET /api/planner-dashboard/booking-appointment/calendar/?timezone=...&month=YYYY-MM
 */
export const getPreneedBookingAppointmentCalendar = (params: {
  timezone: string; // "Asia/kolkata"
  month: string;    // "2026-02"
}) => {
  return customaxios({
    method: "GET",
    url: `/planner-dashboard/booking-appointment/calendar/`,
    params,
    headers: authHeader,
  });
};

/**
 * 2) Bookings by selected date (right side list)
 * GET /api/planner-dashboard/booking-appointment/by-date/?timezone=...&date=YYYY-MM-DD
 */
export const getPreneedBookingAppointmentsByDate = (params: {
  timezone: string; // "Asia/kolkata"
  date: string;     // "2026-02-16"
}) => {
  return customaxios({
    method: "GET",
    url: `/planner-dashboard/booking-appointment/by-date/`,
    params,
    headers: authHeader,
  });
};

/**
 * 3) Booking details screen
 * NOTE: orderId = bookingId from calendar/by-date response
 * GET /api/planner-dashboard/booking-appointment/details/:orderId?timezone=...
 */
export const getPreneedBookingAppointmentDetails = (params: {
  timezone: string;                 // "Asia/Kolkata"
  bookingId: number | string;       // numeric bookingId from calendar API
}) => {
  const { bookingId, timezone } = params;

  // in case someone accidentally passes "#ORD000959", try to extract digits
  const numericId =
    typeof bookingId === "string"
      ? bookingId.replace(/[^\d]/g, "")
      : String(bookingId);

  return customaxios({
    method: "GET",
    url: `/planner-dashboard/booking-appointment/details/${numericId}`,
    params: { timezone },
    headers: authHeader,
  });
};

export const uploadPreneedBookingDocuments = (orderId: number | string, formData: FormData) => {
  return customaxios({
    method: "POST",
    url: `/planner-dashboard/booking-appointment/upload-documents/${orderId}`,
    data: formData,
    headers: {
      ...authHeader,
      "Content-Type": "multipart/form-data",
    },
  });
}

export const deletePreneedBookingDocument = (documentId: number | string) => {
  return customaxios({
    method: "DELETE",
    url: `/planner-dashboard/booking-appointment/delete-document/${documentId}`,
    headers: authHeader,
  });
}
export const getPreneedBookingRequests = (params: any) => {
  return customaxios({
    method: "GET",
    url: "/planner-dashboard/booking-appointment",
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const resendPreneedPaymentLink = (leadId: number | string) => {
  return customaxios({
    method: "POST",
    url: `/planner-dashboard/booking-appointment/leads/${leadId}/resend-payment-link`,
    headers: authHeader,
  });
};
export const updateBookingStatus = (orderId: number | string) => {
  return customaxios({
    method: "POST",
    url: `/planner-dashboard/booking-appointment/completed/${orderId}`
  });
}



